import { render, staticRenderFns } from "./VariantSifterDataTableModal.vue?vue&type=template&id=54fee261&scoped=true&"
import script from "./VariantSifterDataTableModal.vue?vue&type=script&lang=js&"
export * from "./VariantSifterDataTableModal.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterDataTableModal.vue?vue&type=style&index=0&id=54fee261&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fee261",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fee261')) {
      api.createRecord('54fee261', component.options)
    } else {
      api.reload('54fee261', component.options)
    }
    module.hot.accept("./VariantSifterDataTableModal.vue?vue&type=template&id=54fee261&scoped=true&", function () {
      api.rerender('54fee261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterDataTableModal.vue"
export default component.exports